import React from 'react';

const PJGatling = ({ width = '29.21', height = '16', className, ...rest }) => {
  return (
    <svg
      viewBox="0 0 29.21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      role="presentation"
      aria-hidden="true"
      {...rest}
    >
      <defs id="defs1">
        <style id="style1">{'.fill-color-1{fill:#6161d6;}'}</style>
      </defs>
      <path
        className="fill-color-1"
        d="M23.293 14.464a6.572 6.572 0 0 0 2.048 -1.899h0.942a0.867 0.867 0 1 0 0 -1.734h-0.075a6.572 6.572 0 0 0 0.329 -1.723h0.927a0.867 0.867 0 1 0 0 -1.734h-0.957a6.572 6.572 0 0 0 -0.418 -1.723h0.179a0.867 0.867 0 1 0 0 -1.734h-1.167A6.664 6.664 0 0 0 19.914 1.419h-1.481a6.572 6.572 0 0 0 -2.631 0.553h1.554a6.536 6.536 0 0 1 0.822 13.029 7.303 7.303 0 0 1 -0.597 0.029H10.855a8.033 8.033 0 0 0 2.737 -2.466 0.548 0.548 0 0 0 0.15 0.015h5.858a0.867 0.867 0 1 0 0 -1.734H14.505a8.398 8.398 0 0 0 0.447 -1.723h6.715a0.867 0.867 0 1 0 0 -1.734H15.029a8.033 8.033 0 0 0 -0.329 -1.723h4.935a0.867 0.867 0 0 0 0 -1.734h-5.696A7.996 7.996 0 0 0 7.056 0h-0.568A7.996 7.996 0 0 0 0 3.348a7.129 7.129 0 0 1 12.091 2.235H8.478A3.929 3.929 0 0 0 1.482 8.1a3.929 3.929 0 0 0 7.071 2.298H4.814a3.122 3.122 0 0 1 3.125 -3.125h4.56q0.046 0.38 0.046 0.763A7.129 7.129 0 0 1 0.152 12.845a7.996 7.996 0 0 0 6.351 3.155H18.22c6.07 0 10.988 -0.358 10.988 -0.822 0.004 -0.296 -2.403 -0.579 -5.917 -0.714"
        id="path1"
      />
    </svg>
  );
};

export default PJGatling;
